import dayjs from "dayjs"
import { Timestamp, toDate } from "raml-lib"

export function RelativeTimestamp({ value }: { value: Timestamp }) {
  return <small>{dayjs(toDate(value)).fromNow()}</small>
}
